// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstructionsController from "./instructions_controller"
application.register("instructions", InstructionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedTasksController from "./nested_tasks_controller"
application.register("nested-tasks", NestedTasksController)

import TimeCalculatorController from "./time_calculator_controller"
application.register("time-calculator", TimeCalculatorController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import TaskNotifierController from "./task_notifier_controller"
application.register("task-notifier", TaskNotifierController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PivotForwardController from "./pivot_forward_controller"
application.register("pivot-forward", PivotForwardController)

import CardLinkController from "./card_link_controller"
application.register("card-link", CardLinkController)

import PwaUpdateController from "./pwa_update_controller"
application.register("pwa-update", PwaUpdateController)
